import { entityEffects, selectCurrentEntity, selectEntityDisplayName } from '@opengov/app-core/entity';
import { coreFeatureFlagEffects } from '@opengov/app-core/featureFlag';
import { ensureAll } from '@opengov/compose-app-router/onEnter';
import { routerActions } from '@opengov/compose-app-router/state';
import { createSelector } from '@opengov/compose-app/reselect';
import { IEntity } from '@opengov/og-api-ts';
import { generatePageTitle } from '@opengov/stories-shared/utils';

import { onEnterStoriesRoutes } from '../../routes/onEnter';
import { maintenancePath, publicationListPath, storyListPath} from '../../routes/paths';
import { StoryList } from '../components';
import { selectStoryListProps } from '../selectors';

export const storyListRoute = {
  name: 'StoryList',
  title: createSelector(selectEntityDisplayName, (name) => generatePageTitle('Home', name)),
  selector: selectStoryListProps,
  component: StoryList,
  onEnter: ensureAll([
    onEnterStoriesRoutes,
    async (state, nextLocation, onSuccess, onError) => {
      const { entitySubdomain } = nextLocation.params;
      await entityEffects
        .fetchRequestedOrCurrentEntity({
          requestedEntitySubdomain: entitySubdomain,
          currentEntity: selectCurrentEntity(state)
        })
        .then(async (entity: IEntity) => {
          if (entity.subdomain !== entitySubdomain) {
            return onError(
              'Entity not found...',
              routerActions.replace.create({ pathname: storyListPath(entity.subdomain) })
            );
          }

          await coreFeatureFlagEffects.getFlags().then(async (flags) => {
            if (flags && flags['product-stories-maintenance-window']) {
              return onError(
                'Redirecting to maintenance page...',
                routerActions.replace.create({ pathname: maintenancePath(entitySubdomain) })
              );
            }

            onSuccess();
          });
        });
    }
  ])
};

export const templateListRoute = {
  name: 'TemplateList',
  title: createSelector(selectEntityDisplayName, (name) => generatePageTitle('Home', name)),
  selector: selectStoryListProps,
  component: StoryList,
  onEnter: ensureAll([
    onEnterStoriesRoutes,
    async (state, nextLocation, onSuccess, onError) => {
      const { entitySubdomain } = nextLocation.params;
      await entityEffects
        .fetchRequestedOrCurrentEntity({
          requestedEntitySubdomain: entitySubdomain,
          currentEntity: selectCurrentEntity(state)
        })
        .then(async (entity: IEntity) => {
          if (entity.subdomain !== entitySubdomain) {
            return onError(
              'Entity not found...',
              routerActions.replace.create({ pathname: storyListPath(entity.subdomain) })
            );
          }

          await coreFeatureFlagEffects.getFlags().then(async (flags) => {
            if (flags && flags['product-stories-maintenance-window']) {
              return onError(
                'Redirecting to maintenance page...',
                routerActions.replace.create({ pathname: maintenancePath(entitySubdomain) })
              );
            }

            onSuccess();
          });
        });
    }
  ])
};

export const publicationListRoute = {
  name: 'PublicationList',
  title: createSelector(selectEntityDisplayName, (name) => generatePageTitle('Home', name)),
  selector: selectStoryListProps,
  component: StoryList,
  onEnter: ensureAll([
    onEnterStoriesRoutes,
    async (state, nextLocation, onSuccess, onError) => {
      const { entitySubdomain } = nextLocation.params;
      await entityEffects
        .fetchRequestedOrCurrentEntity({
          requestedEntitySubdomain: entitySubdomain,
          currentEntity: selectCurrentEntity(state)
        })
        .then(async (entity: IEntity) => {
          if (entity.subdomain !== entitySubdomain) {
            return onError(
              'Entity not found...',
              routerActions.replace.create({ pathname: publicationListPath(entity.subdomain) })
            );
          }

          await coreFeatureFlagEffects.getFlags().then(async (flags) => {
            if (flags && flags['product-stories-maintenance-window']) {
              return onError(
                'Redirecting to maintenance page...',
                routerActions.replace.create({ pathname: maintenancePath(entitySubdomain) })
              );
            }

            onSuccess();
          });
        });
    }
  ])
};
